import Welcome from "./Welcome";
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { createUserForLbpAsync, getUserDetailsAsync, readAppState } from "../../redux/reducers/appReducer";
// import * as jwt from "jsonwebtoken";
import jwt_decode from "jwt-decode";

const LBPWelcome = (props : any) => {
    const dispatch = useAppDispatch();
    const appState = useAppSelector(readAppState);
    console.log('appState.userDetailFetched',appState.userDetailFetched)
    // console.log('jenkins pipeline testing for dev')

    useEffect(() => {
        let lbptoken = props.lbpToken;
        if (lbptoken && !appState.userDetailFetched) {
           // let decodedData: any = jwt.decode(lbptoken);
           let  decodedData: any = jwt_decode(lbptoken);
           const token=JSON.parse(decodedData.data);
           if (token.username) {
                let params = {
                    loan_id: token.loan_id,
                    username: token.username,
                    servicer_id: token.servicer_id,
                    // borrower_id: decodedData.borrower_id
                };
                dispatch(createUserForLbpAsync(params)).then(() => {
                    const data = { userId: token.username, password: null }
                    console.log('data..hoa',data)
                    dispatch(getUserDetailsAsync(data));
                })
            }
        }
    }, []);

    return (<>
        {!appState.userDetailFetched && <Welcome />}         
    </>);
}

export default LBPWelcome;